import { Restaurant } from '@local/api';

import { MAX_ORDER_CLOSURE_DESCRIPTION } from 'helpers/constants';

import { isClosed } from './restaurantFulfillment';

/**
 * Returns a boolean that describes if a restaurant is live for Marketplace (formerly Discover)
 * live meaning they are signed up, and everything is configured correctly to support taking orders, such as menu, hours, etc.
 * @param restaurant
 */
export const isMarketplaceLive = (
  restaurant: Pick<Restaurant, 'is_discover_live'>
): boolean => {
  return !!restaurant.is_discover_live;
};

export const isOrderBotClosure = (
  restaurant: Pick<Restaurant, 'closures'> | undefined
): boolean => {
  return !!restaurant?.closures?.some(
    (closure) => closure.description === MAX_ORDER_CLOSURE_DESCRIPTION
  );
};

export const isTemporarilyUnavailable = (
  restaurant: Pick<
    Restaurant,
    'closures' | 'fulfillment' | 'order_ahead' | 'allows_order_for_now'
  >
): boolean => isClosed(restaurant) || isOrderBotClosure(restaurant);

export const getMenuNextAvailableTime = (
  restaurant: Pick<Restaurant, 'fulfillment'> | undefined
): string | null =>
  restaurant?.fulfillment?.pickup?.next_available_time ||
  restaurant?.fulfillment?.delivery?.next_available_time ||
  null;
